import { PaymentTerm_Read, PaymentTerm_Read_Nested } from '@treadinc/horizon-api-spec';
import dayjs from 'dayjs';
import { Dayjs } from 'dayjs';

export class PaymentTermBasic {
  constructor(
    private _id: string,
    private _name: string,
    private _due_days: number,
    private _active: boolean,
  ) {}

  public static parse(proto: PaymentTerm_Read_Nested) {
    return new PaymentTermBasic(proto.id, proto.name, proto.due_days, proto.active);
  }

  public get id() {
    return this._id;
  }

  public get name() {
    return this._name;
  }

  public get dueDays() {
    return this._due_days;
  }

  public get active() {
    return this._active;
  }
}

export class PaymentTerm {
  constructor(
    private _id: string,
    private _name: string,
    private _due_days: number,
    private _active: boolean,
    private _created_at: Dayjs | null = null,
  ) {}

  public static parse(proto: PaymentTerm_Read) {
    return new PaymentTerm(
      proto.id,
      proto.name,
      proto.due_days,
      proto.active,
      proto.created_at ? dayjs(proto.created_at) : null,
    );
  }

  public get id() {
    return this._id;
  }

  public get name() {
    return this._name;
  }

  public get dueDays() {
    return this._due_days;
  }

  public get active() {
    return this._active;
  }

  public get createdAt() {
    return this._created_at;
  }
}
